import React from 'react';
import classnames from 'classnames';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Progress from '../progress';
import { animationTimeout } from '../animation';

// Gets the display name of a JSX component for dev tools
function getComponentDisplayName(Component) {
  return Component.displayName || Component.name || 'Unknown';
}

// This HOC provides animated progress bar in a child component,
// This is needed to decouple loading components with transition and animation dependencies
export default ({
  isLoading = props => props.loading,
} = {}) => (WrappedComponent) => {
  const withLoading = ({ className, ...props }) => {
    const loading = isLoading(props);

    return (
      <WrappedComponent
        className={classnames(
          className,
          'with-loading',
        )}
        loadingComponent={
          <TransitionGroup className="with-loading-container">
            {loading && (
              <CSSTransition key="progress" classNames="progress" timeout={animationTimeout}>
                <Progress className="progress" />
              </CSSTransition>
            )}
          </TransitionGroup>
        }
        {...props}
      />
    );
  };

  withLoading.displayName = `withLoading(${getComponentDisplayName(WrappedComponent)})`;

  return withLoading;
};
